import { render } from "./ChangeOrderCreateReviewPanel.vue?vue&type=template&id=42a5a0da"
import script from "./ChangeOrderCreateReviewPanel.vue?vue&type=script&lang=js"
export * from "./ChangeOrderCreateReviewPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__